export default "__VITE_ASSET__Dqwvi08A__"